@import '../../../utils/global.module.less';

.panelRowDivier {
    height: 3px;
    background-color: #eaecf0;
    width: 100%;
}
